import { render, staticRenderFns } from "./copyright-memberevolution.vue?vue&type=template&id=5e802d40&scoped=true"
import script from "./copyright-memberevolution.vue?vue&type=script&lang=js"
export * from "./copyright-memberevolution.vue?vue&type=script&lang=js"
import style0 from "./copyright-memberevolution.vue?vue&type=style&index=0&id=5e802d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e802d40",
  null
  
)

export default component.exports